export const categories = [
  {
    id: 'zuixin-jingxuan',
    name: '最新精选',
    slug: 'zuixin-jingxuan',
    description: '每日更新最优质的国产原创内容，第一时间获取最新资源',
    icon: 'ri-sparkling-line',
    color: 'primary',
  },
  {
    id: 'remen-tuijian',
    name: '热门推荐',
    slug: 'remen-tuijian',
    description: '汇聚全网最受欢迎的国产原创精品内容',
    icon: 'ri-fire-line',
    color: 'accent',
  },
  {
    id: 'yingshi-zongyu',
    name: '影视综娱',
    slug: 'yingshi-zongyu',
    description: '国产电影、电视剧、综艺节目的深度解读与精彩盘点',
    icon: 'ri-movie-2-line',
    color: 'primary',
  },
  {
    id: 'keji-shuma',
    name: '科技数码',
    slug: 'keji-shuma',
    description: '国产科技创新、数码产品评测与行业前沿动态',
    icon: 'ri-smartphone-line',
    color: 'accent',
  },
  {
    id: 'shenghuo-baike',
    name: '生活百科',
    slug: 'shenghuo-baike',
    description: '贴近生活的实用技巧、健康养生与美食文化分享',
    icon: 'ri-heart-pulse-line',
    color: 'primary',
  },
  {
    id: 'wenxue-yishu',
    name: '文学艺术',
    slug: 'wenxue-yishu',
    description: '国产原创文学、诗词歌赋、书法绘画等艺术鉴赏',
    icon: 'ri-quill-pen-line',
    color: 'accent',
  },
  {
    id: 'yinyue-tiandi',
    name: '音乐天地',
    slug: 'yinyue-tiandi',
    description: '华语音乐推荐、独立音乐人作品与音乐文化探讨',
    icon: 'ri-music-line',
    color: 'primary',
  },
  {
    id: 'youxi-dongman',
    name: '游戏动漫',
    slug: 'youxi-dongman',
    description: '国产游戏评测、动漫推荐与二次元文化深度解析',
    icon: 'ri-gamepad-line',
    color: 'accent',
  },
];